import ExcelJS from "exceljs";
import { ProductWithStockItem } from "./common/types/server-data.types";
import { buildWorkbook } from "./common/exporter/buildWorkbook";
import { diffWorkbook } from "./common/diff/diff-workbook";
import { DB_SHEET_NAME } from "./common/const/excel.const";
import { convertDataSheetToProductData } from "./common/importer/convert-data-sheet-to-product-data";
import { ExcelExportOptions, ProductClassificationInfo, SummaryTitleOptions, } from "./common/types/export-excel.types";
/**
 * @description 엑셀 서비스
 *
 * - _downloadExcel_node: 노드 환경에서 엑셀 파일 다운로드
 * - _downloadExcel_browser: 브라우저 환경에서 엑셀 파일 다운로드
 * - _downloadExcel: 환경에 따라 적절한 다운로드 함수 호출
 *
 * - export: 엑셀 파일 생성 및 다운로드
 * - diff: 두 엑셀 파일의 차이점 비교 및 결과 엑셀 파일 생성
 */
export const ERPExcelService = {
    _downloadExcel_node: async (workbook, fileName) => {
        await workbook.xlsx.writeFile(fileName);
    },
    _downloadExcel_browser: async (workbook, fileName) => {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
    },
    _downloadExcel: async (workbook, fileName) => {
        // 브라우저 여부에 따른 다운로드 처리
        const isBrowser = typeof window !== "undefined";
        if (isBrowser) {
            await ERPExcelService._downloadExcel_browser(workbook, fileName);
        }
        else {
            await ERPExcelService._downloadExcel_node(workbook, fileName);
        }
    },
    parse: async (file, showPrice) => {
        const buffer = await file.arrayBuffer();
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet(DB_SHEET_NAME);
        if (!worksheet) {
            throw new Error(`${DB_SHEET_NAME} 시트를 찾을 수 없습니다.`);
        }
        return convertDataSheetToProductData(worksheet, showPrice);
    },
    // 내보내기
    export: async (data, fileName = "tmp", summarySheetOptions) => {
        if (fileName === "tmp") {
            fileName = `재고_${new Date().toISOString().slice(0, 10)}.xlsx`;
        }
        const workbook = buildWorkbook(data, summarySheetOptions);
        await ERPExcelService._downloadExcel(workbook, fileName);
    },
    // 차이표 생성
    diff: async (oldData, newData, fileName = "tmp") => {
        if (fileName === "tmp") {
            fileName = `재고_DIFF_${new Date().toISOString().slice(0, 10)}.xlsx`;
        }
        const workbook = diffWorkbook(oldData, newData);
        await ERPExcelService._downloadExcel(workbook, fileName);
    },
};
